// Generated by CoffeeScript 1.9.3
var _LinePrependor;

module.exports = _LinePrependor = (function() {
  function _LinePrependor(_config) {
    this._config = _config;
    this._lineNo = -1;
  }

  _LinePrependor.prototype.render = function(inherited, options) {
    this._lineNo++;
    return '<none>' + this._render(inherited, options) + '</none>';
  };

  return _LinePrependor;

})();



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/layout/block/linePrependor/_LinePrependor.js
// module id = 3844
// module chunks = 0